import { Injectable, Signal } from '@angular/core'

@Injectable({ providedIn: 'root' })
export abstract class ConsentService {
	abstract ask(): Promise<void>
	abstract canShowForm: Signal<boolean | undefined>
}
